import { useCallback } from 'react';
import { ERoutes } from '../enums';
import { customToast } from '../utils';
import { useTranslation } from 'react-i18next';
import { useAvailableQuizzState } from './useAvailableQuizzState';
import { useNavigate } from 'react-router';

//TODO: Add available state for other flows
export const useDeepLinkNavigate = () => {
  const isQuizzAvailable = useAvailableQuizzState();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const navigateByPathname = useCallback(
    (pathname: string) => {
      switch (pathname) {
        case ERoutes.quizz:
        case ERoutes.quizzStart:
          if (!isQuizzAvailable) {
            customToast(
              {
                title: t('quizz.quiz_unlocks_soon'),
                subtitle: t('quizz.quizz_not_available_try_again_later'),
              },
              'info',
            );
            break;
          }
          navigate(pathname);
          break;
        default:
          navigate(pathname);
          break;
      }
    },
    [isQuizzAvailable, navigate, t],
  );

  return navigateByPathname;
};
